export var NON_DIGITS_REGEX = /[^\d]+/g;
export var POJOB_NAME_REGEX = /^[a-zA-Z0-9&#;@. ]+$/;
